import React, { useState } from "react"

import type { BoxProps } from "@chakra-ui/react"
import {
  Box,
  Button,
  Input,
  Popover,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverTrigger,
  Stack,
  Textarea,
  Tooltip,
  useDisclosure,
} from "@chakra-ui/react"

import { Labeled } from "components/Labeled"
import { useSendBugReport } from "lib/hooks/useSendBugReport"

type BugReportProps = BoxProps

export const BugReport = ({ ...rest }: BugReportProps) => {
  const [what, setWhat] = useState("")
  const [loomLink, setLoomLink] = useState("")
  const sendBugReport = useSendBugReport()
  const popoverProps = useDisclosure()

  const handleSubmit = () => {
    sendBugReport({
      what,
      details: {
        "Loom recording": loomLink,
        "Submitted from URL": window.location.href,
      },
      onSuccess: () => {
        popoverProps.onClose()
        setLoomLink("")
        setWhat("")
      },
    })
  }

  return (
    <Popover {...popoverProps}>
      <PopoverTrigger>
        <Box {...rest}>
          <Tooltip label="Report bug">
            <Button
              variant="ghost"
              size="xs"
              colorScheme="red"
              onClick={popoverProps.onOpen}
            >
              🐞
            </Button>
          </Tooltip>
        </Box>
      </PopoverTrigger>

      <PopoverContent>
        <PopoverHeader border="none">Report bug</PopoverHeader>

        <PopoverCloseButton />
        <PopoverBody>
          <Stack spacing={4}>
            <Box>
              <Labeled label="What happened?">
                <Textarea
                  size="sm"
                  value={what}
                  onChange={(event) => setWhat(event.target.value)}
                />
              </Labeled>
            </Box>

            <Box>
              <Labeled label="Link to Loom recording">
                <Input
                  size="sm"
                  value={loomLink}
                  onChange={(event) => setLoomLink(event.target.value)}
                />
              </Labeled>
            </Box>
          </Stack>
        </PopoverBody>

        <PopoverFooter
          mt={2}
          display="flex"
          w="full"
          border="none"
          justifyContent="flex-end"
        >
          <Tooltip
            shouldWrapChildren
            label={
              !what
                ? "Please describe what you expected and what actually happenend"
                : !loomLink
                  ? "The Loom field is empty. Please do a screen recording with Loom. This is a tremendous help to fix bugs"
                  : null
            }
          >
            <Button
              size="sm"
              onClick={handleSubmit}
              isDisabled={!(what && loomLink)}
            >
              Submit
            </Button>
          </Tooltip>
        </PopoverFooter>
      </PopoverContent>
    </Popover>
  )
}
